import React, { lazy, Suspense } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { RoutePermissionGuard } from '@shared/auth/RoutePermissionGuard';
import { Role } from '@shared/auth/AuthContext';

const BranchesPage = lazy(() => import('./modules/branches/pages/BranchesPage'));
const ApprovalsPage = lazy(() => import('./modules/approvals/pages/ApprovalsPage'));
const AutomationsPage = lazy(() => import('./modules/automations/pages/AutomationsPage'));
const AssetsPage = lazy(() => import('./modules/assets/pages/AssetsPage'));
const VisitorsPage = lazy(() => import('./modules/visitors/pages/VisitorsPage'));

const LoadingFallback: React.FC = () => (
  <div className="flex h-64 items-center justify-center">
    <div className="h-6 w-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const BRANCH_ROLES: Role[] = ['owner', 'admin', 'branch_head'];
const APPROVAL_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'counselor', 'accountant', 'teacher'];
const AUTOMATION_ROLES: Role[] = ['owner', 'admin'];
const ASSET_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'accountant'];
const VISITOR_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'counselor'];

export const operationsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="branches" replace />,
  },
  {
    path: 'branches',
    handle: { crumb: 'Campus Branches' },
    element: (
      <RoutePermissionGuard permission="ops.branches.manage" allowedRoles={BRANCH_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <BranchesPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'approvals',
    handle: { crumb: 'Approval Workflows' },
    element: (
      <RoutePermissionGuard permission="ops.approvals.request" allowedRoles={APPROVAL_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <ApprovalsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'automations',
    handle: { crumb: 'Event Automations' },
    element: (
      <RoutePermissionGuard permission="ops.automations.manage" allowedRoles={AUTOMATION_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <AutomationsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'assets',
    handle: { crumb: 'Asset Inventory' },
    element: (
      <RoutePermissionGuard permission="ops.assets.manage" allowedRoles={ASSET_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <AssetsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'visitors',
    handle: { crumb: 'Visitor Log' },
    element: (
      <RoutePermissionGuard permission="ops.visitors.manage" allowedRoles={VISITOR_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <VisitorsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
];

export default operationsRoutes;
